module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_jk-3c8456155ca75d074a10398cefd10ae4.png";